import React from "react";

const Folder = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3823 4.16778C9.98728 3.773 9.45176 3.55109 8.89329 3.55078H4.42729C3.86874 3.55078 3.33307 3.77266 2.93812 4.16761C2.54317 4.56257 2.32129 5.09824 2.32129 5.65678V6.63378H12.8483L10.3823 4.16778ZM20.2163 7.63378H2.32129V20.3178C2.32129 21.4808 3.26429 22.4228 4.42729 22.4228H20.2163C20.4928 22.4229 20.7665 22.3686 21.022 22.2628C21.2774 22.1571 21.5095 22.002 21.705 21.8065C21.9005 21.611 22.0556 21.3789 22.1613 21.1235C22.2671 20.868 22.3214 20.5943 22.3213 20.3178V9.73878C22.3214 9.46231 22.2671 9.18853 22.1613 8.93308C22.0556 8.67763 21.9005 8.44552 21.705 8.25003C21.5095 8.05453 21.2774 7.89949 21.022 7.79375C20.7665 7.68801 20.4928 7.63365 20.2163 7.63378Z"
        fill="white"
      />
    </svg>
  );
};

export default Folder;
